import {
  useMutation,
  useQueryClient,
  type UseMutationOptions,
} from '@tanstack/react-query';
import { toast } from '@/shared/hooks/use-toast';
import { presetApi } from '../api';
import { presetKeys } from './preset.keys';

type DeleteGalleryResponse = { success: boolean };

export function useDeletePresetGallery(
  presetId?: string,
  options?: UseMutationOptions<DeleteGalleryResponse, Error, string>
) {
  const queryClient = useQueryClient();
  const { onSuccess: providedOnSuccess, onError: providedOnError, ...mutationOptions } = options ?? {};
  const mutation = useMutation({
    mutationKey: ['presets', 'delete-gallery'],
    mutationFn: presetApi.deleteGallery,
    ...mutationOptions,
    onSuccess: (_, galleryUuid, onMutateResult, context) => {
      if (presetId) {
        queryClient.invalidateQueries({ queryKey: presetKeys.galleries(presetId) });
      }
      queryClient.invalidateQueries({ queryKey: presetKeys.all });
      providedOnSuccess?.(_, galleryUuid, onMutateResult, context);
    },
    onError: (error, variables, onMutateResult, context) => {
      toast({
        title: 'Erro ao remover galeria',
        description: error.message,
        variant: 'destructive',
      });
      providedOnError?.(error, variables, onMutateResult, context);
    },
  });
  const deleteGallery = (galleryUuid: string) => mutation.mutateAsync(galleryUuid);
  return {
    deleteGallery,
    isLoading: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
    mutationResult: mutation,
  };
}
